import { Button, CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { buildStatistics, fetchStatistics } from "../api/statisticsAPI";
import PlayerStatisticsGrid from "../components/PlayerStatisticsGrid";
import { useSeason } from "../components/SeasonContext";
import { useAuth } from "../context/AuthContext";
import { TeamStatistic } from "../interfaces";
import { PageHeader } from "./PageHeader";

const AdminStatisticsView: React.FC = () => {
  const { selectedSeason } = useSeason();
  const [statistics, setStatistics] = React.useState<TeamStatistic[]>([]);
  const [loading, setLoading] = React.useState(false);
  const handleBuildStatistics = async () => {
    try {
      setLoading(true);
      const res = await buildStatistics(selectedSeason);

      alert(res.message || "Statistiken erfolgreich erstellt.");
      const res_stats = await fetchStatistics(selectedSeason);

      setStatistics(res_stats);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleFetchStatistics = async () => {
      try {
        setLoading(true);
        const res = await fetchStatistics(
          localStorage.getItem("selectedSeason") || ""
        );
        setStatistics(res);
      } catch (err) {
        console.error("Failed to fetch statistics", err);
      } finally {
        setLoading(false);
      }
    };

    handleFetchStatistics();
  }, [selectedSeason]);

  const { isAuthenticated } = useAuth();
  console.log("isAuthenticated", isAuthenticated);

  return (
    <Box>
      {/* <SeasonSelect /> */}
      <PageHeader title="Statistiken" withStatistiksNav={false} />
      <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
        {!loading ? (
          <PlayerStatisticsGrid
            data={statistics.map((teamStat) => ({
              ...teamStat,
              players: teamStat.players.map((player) => ({
                ...player,
                season: {
                  ...player.season,
                  id:
                    typeof player.season.id === "string"
                      ? Number(player.season.id)
                      : player.season.id,
                },
              })),
            }))}
          />
        ) : (
          <CircularProgress sx={{ mt: 8 }} />
        )}
      </Box>
      {isAuthenticated && (
        <Box sx={{ marginBlock: 2 }}>
          <Link to="/spielplan?displayOption=spieltag">
            Zur Spieltagsübersicht
          </Link>
          <Button
            sx={{ ml: 2 }}
            variant="contained"
            onClick={handleBuildStatistics}
          >
            Statistikenauswerten
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default AdminStatisticsView;
